import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes, FilterType,
} from 'app/enums/common.enums'

import {
    ContainerCode, ContainerVolume, TemperatureRange,
} from 'app/enums/label.enums'

const config: SkyNetTableConfig = {
    name: 'ContainerTypes',
    tabs: [{
        name: 'Container Type',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'containerModel',
                reduced: true,
            },
            {
                name: 'containerCode',
                reduced: true,
                componentName: 'EnumValue',
                allowedValuesEnum: ContainerCode,
                filterType: FilterType.Array,
                filterField: 'containerCode',
            },
            {
                name: 'containerVolume',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: ContainerVolume,
                filterField: 'containerVolume',
            },
            {
                name: 'temperatureRange',
                reduced: true,
                componentName: 'EnumValue',
                allowedValuesEnum: TemperatureRange,
            },
            {
                name: 'isPrototype',
                componentName: 'ChipCheckMark',
                sorting: false,
                filterType: FilterType.Array,
                filterField: 'isPrototype',
            },
        ],
    }],
}

export default config
